export let ANALYTICS_API_URL = 'http://localhost:3000/data';
if ((window.location.href.indexOf('local') >= 0)) {
    ANALYTICS_API_URL = 'http://localhost:3000/data';
}
else {
    ANALYTICS_API_URL = 'https://de-pacman.sam-media.com/api/v2/mstore';
}

export const unsubLinks = {
    se: 'http://n.mobioastro.com/unsubscribe/se/?country=se&domain=se.mobioastro.com&token=',
    eg: 'http://n.mobioastro.com/unsubscribe/eg?token=',
    es: 'http://n.apps4u.cc/unsubscribe/mx/?domain=chat.migente.club&platform=yamato&token=',
    mx: 'http://n.apps4u.cc/unsubscribe/mx/?domain=chat.migente.club&platform=yamato&token=',
    ps: 'http://n.mobioastro.com/unsubscribe/ps?token=',
    jo: 'http://n.mobioastro.com/unsubscribe/jo?token=',
    no: 'http://n.mobioastro.com/unsubscribe/no/?domain=no.mobioastro.com&token=',
    pl: 'http://n.mobioastro.com/unsubscribe/pl/?domain=pl.mobioastro.com&token=',
    fr: 'http://n.mobioastro.com/unsubscribe/fr/?domain=fr.mobioastro.com&token=',
    ie: 'http://n.mobioastro.com/unsubscribe/ie/?domain=ie.mobioastro.com&token=',
    za: 'http://n.mobioastro.com/unsubscribe/za/?token=',
    ro:  'http://n.mobioastro.com/unsubscribe/ro/?country=ro&domain=ro.mobioastro.com&token=',
    localhost: 'http://localTestLinkForUnsub'
}



// WEBPACK FOOTER //
// ./src/constants.js